import useAxios from "./useAxios"
import useAxiosDispatch from "./axiosDispatch"
import { momentDate, returnCurrentDate } from "./helper"
import useGetData from "./useGetData"
import useHandleOrder from "./useHandleOrder"
import usecheckPermison from "./checkPermison"
// import useCheckPermison from "./useAccessPermsion"
import FetchData from "./useFetchData"
import useDownloadFile from "./useDownloadFile"
import constants from "src/constant"
const index = {
    useAxios,
    useAxiosDispatch,
    momentDate,
    currentDate: returnCurrentDate,
    useData: useGetData,
    useHandleOrder: useHandleOrder,
    usePermision: usecheckPermison,
    // useCheckPermison: useCheckPermison,
    const: constants,
    usefetchData: FetchData,
    useDownloadFile: useDownloadFile
}
export default index
